import request from '@/utils/request'

// 加入购物车
export const addGoodToCartApi = ({ goodsId, goodsNum, goodsSkuId }) => {
  return request.post('/cart/add', {
    goodsId,
    goodsNum,
    goodsSkuId
  })
}

// 获取购物车商品列表
export const getCartListApi = () => {
  return request.get('/cart/list')
}

// 购物车商品更新
export const updateCartGoodsApi = ({ goodsId, goodsNum, goodsSkuId }) => {
  return request.post('/cart/update', {
    goodsId,
    goodsNum,
    goodsSkuId
  })
}

// 删除购物车商品
export const deleteCartGoodsApi = (cartIds) => {
  return request.post('/cart/clear', {
    // 要删除商品的对应cartId列表
    cartIds
  })
}

// 获取购物车商品总数量
export const getCartTotalNumApi = () => {
  return request.get('/cart/total')
}
